import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'

import {
  IMentionedInMessageNotificationTypeInterfaces,
} from '@toolify/server/src/services/NotificationService/strategies/IMentionedInMessageNotificationTypeInterfaces'
import {i18n} from '@toolify/client/src/setup/i18n'

const {t} = i18n.global

export const GetMentionedInMessageNotificationTitleByConversationTypeMap = new Map<ConversationType,(authorNick: string, payload: IMentionedInMessageNotificationTypeInterfaces['payload']) => string>([
  [ConversationType.Workspace, (authorNick: string, payload: IMentionedInMessageNotificationTypeInterfaces['payload']) => {
    const typedPayload = payload as IMentionedInMessageNotificationTypeInterfaces<ConversationType.Workspace>['payload']
    return t('notifications.browserNotifications.mentionedInMessage.workspace', {
      author: authorNick,
      name: typedPayload.conversationNotificationPayload.workspaceConversationName,
    })
  }],
  [ConversationType.CloudFile, (authorNick: string, payload: IMentionedInMessageNotificationTypeInterfaces['payload']) => {
    const typedPayload = payload as IMentionedInMessageNotificationTypeInterfaces<ConversationType.CloudFile>['payload']
    return t('notifications.browserNotifications.mentionedInMessage.cloudFile', {
      author: authorNick,
      folder: typedPayload.conversationNotificationPayload.folderName,
      item: typedPayload.conversationNotificationPayload.cloudItemName,
    })
  }],
  [ConversationType.DatabaseCell, (authorNick: string, payload: IMentionedInMessageNotificationTypeInterfaces['payload']) => {
    const typedPayload = payload as IMentionedInMessageNotificationTypeInterfaces<ConversationType.DatabaseCell>['payload']
    return t('notifications.browserNotifications.mentionedInMessage.databaseCell', {
      author: authorNick,
      item: typedPayload.conversationNotificationPayload.databaseItemName || t('notifications.browserNotifications.untitledItem'),
      property: typedPayload.conversationNotificationPayload.databasePropertyName,
    })
  }],
  [ConversationType.DatabaseFile, (authorNick: string, payload: IMentionedInMessageNotificationTypeInterfaces['payload']) => {
    const typedPayload = payload as IMentionedInMessageNotificationTypeInterfaces<ConversationType.DatabaseFile>['payload']
    return t('notifications.browserNotifications.mentionedInMessage.databaseFile', {
      author: authorNick,
      item: typedPayload.conversationNotificationPayload.databaseItemName || t('notifications.browserNotifications.untitledItem'),
      file: typedPayload.conversationNotificationPayload.databaseItemFileName,
    })
  }],
  [ConversationType.CallRoom, (authorNick: string, payload: IMentionedInMessageNotificationTypeInterfaces['payload']) => {
    const typedPayload = payload as IMentionedInMessageNotificationTypeInterfaces<ConversationType.CallRoom>['payload']
    return t('notifications.browserNotifications.mentionedInMessage.callRoom', {
      author: authorNick,
      name: typedPayload.conversationNotificationPayload.callRoomName || t('notifications.browserNotifications.untitledCall'),
    })
  }],
  [ConversationType.Direct, (authorNick: string, payload: IMentionedInMessageNotificationTypeInterfaces['payload']) => {
    const typedPayload = payload as IMentionedInMessageNotificationTypeInterfaces<ConversationType.Direct>['payload']
    const name = typedPayload.conversationNotificationPayload.directConversationName
    return name
      ? t('notifications.browserNotifications.mentionedInMessage.direct', {
        author: authorNick,
        name,
      })
      : t('notifications.browserNotifications.mentionedInMessage.directNoName', {author: authorNick})
  }],
])
